/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { IconDownload, IconEye } from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import LocationViewModal from "./LocationViewModal";
import { useFetchPickupLocationData } from "../../../apis/pickupApis";
import useDebounce from "../../../utilities/useDebounce";
import Pagination from "../../../components/common/Pagination";
import EntriesSelector from "../../../components/common/EntriesSelector";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import NoDataFound from "../../../components/common/NoDataFound";

const PickupLocationTab: React.FC = () => {
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [searchFor, setSearchFor] = useState<string>("");
  const debouncedSearchFor = useDebounce(searchFor, 550);
  const [isOpen, setIsOpen] = useState(false);
  const [pickupLocationItem, setPickupLocationItem] = useState<any>(null);

  const { data, refetch, isLoading } = useFetchPickupLocationData(
    pageNo,
    limit,
    debouncedSearchFor
  );

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo, limit]);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  return (
    <>
      <div className="rounded-3xl">
        <div className="flex items-start">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[30px] ">
            <h1 className="text-3xl text-[#212121]">Pickup Location</h1>
            <div className="flex items-center gap-2">
              {data && data.totalPages * limit > 10 && (
                <EntriesSelector
                  value={limit}
                  options={[
                    10,
                    ...(data.totalPages * limit > 10 ? [20] : []),
                    ...(data.totalPages * limit > 20 ? [30] : []),
                    ...(data.totalPages * limit > 50 ? [50] : []),
                    ...(data.totalPages * limit > 100 ? [100] : []),
                  ]}
                  onChange={(val) => {
                    setLimit(val);
                    setPageNo(1);
                  }}
                />
              )}
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1);
                }}
              />
            </div>
          </div>
          <div className="relative ml-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={40}
              height={40}
              viewBox="0 0 34 34"
              fill="none"
              className="absolute -bottom-[12.5px] -left-[22.5px] rotate-[2deg] "
            >
              <path
                d="M0.5 0.5C4.94768 14.4784 15.2221 25.8511 28.6786 31.6907L34 34H2.31268L0.5 0.5Z"
                fill="#F7F6F2"
              />
            </svg>

            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>
        <div>
          {isLoading ? (
            <TableSkeleton
              columns={[
                "S/N",
                "Merchant Name",
                "Pickup Address",
                "Country",
                "City",
                "District",
                "Pincode",
                "Actions",
              ]}
              rows={6}
            />
          ) : !data?.pickupLocations || data.pickupLocations.length === 0 ? (
            <NoDataFound />
          ) : (
            <ListView
              data={data.pickupLocations}
              onRowClick={(client) => console.log("Clicked:", client)}
              columns={[
                { label: "S/N", render: (_, i) => (pageNo - 1) * limit + (i + 1) },
                {
                  label: "Merchant Name",
                  render: (c) => c.clientName || "",
                },
                {
                  label: "Pickup Address",
                  render: (c) => c.fullAddress || "",
                },
                {
                  label: "Country",
                  render: (c) => c.country || "",
                },
                {
                  label: "City",
                  render: (c) => c.city || "",
                },
                {
                  label: "District",
                  render: (c) => c.district || "",
                },
                {
                  label: "Pincode",
                  render: (c) => c.pinCode || "",
                },
                {
                  label: "Actions",
                  render: (c: any) => (
                    <button
                      onClick={() => {
                        setPickupLocationItem(c);
                        openModal();
                      }}
                      className="p-2 border rounded-full bg-[#F7F6F2]"
                    >
                      <IconEye />
                    </button>
                  ),
                },
              ]}
            />
          )}
        </div>

        <div className="py-4 flex justify-center">
          {data?.totalPages > 1 && (
            <Pagination
              totalPages={data?.totalPages}
              currentPage={pageNo}
              fetchData={handlePaginationFetch}
            />
          )}
        </div>
      </div>

      <LocationViewModal
        open={isOpen}
        onClose={closeModal}
        pickupLocationItem={pickupLocationItem}
      />
    </>
  );
};

export default PickupLocationTab;
